// extracted by mini-css-extract-plugin
module.exports = {"sample-code":"sample-code-d932e072dc9f0c89bc25b6a4dd5b94dd","single-sample-message":"single-sample-message-16895b9d63bea8e70734307737272f2c"};